import { render, staticRenderFns } from "./NotifMentionInComment.vue?vue&type=template&id=51599cb4&scoped=true"
import script from "./NotifMentionInComment.vue?vue&type=script&lang=js"
export * from "./NotifMentionInComment.vue?vue&type=script&lang=js"
import style0 from "./NotifStyle.scss?vue&type=style&index=0&id=51599cb4&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51599cb4",
  null
  
)

export default component.exports